module.exports = __webpack_public_path__ + "static/media/landing.57ec3e6c.jpg";